const btnSplitText = () => {
	const VIEW_MOBILE_SIZE = 767;
	const btn = '.js--btn-style';

	if (window.innerWidth > VIEW_MOBILE_SIZE) {
		document.querySelectorAll(btn).forEach(button => {
			const purpose = button.getAttribute('data-purpose');
			button.innerHTML = '<div data-purpose="' + purpose + '"><span>' + button.textContent.trim().split('').join('</span><span>') + '</span></div>';
		});
	}
};

const render = () => {
	btnSplitText();
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/button/btn-style.js